import React from "react"
import { AdressItemTaxo } from "gatsby-theme-blank/src/templates/list/listItems/styled-components/adresse-item-styled"
import { filtersTaxo } from "./ResultsTaxo/listResults.module.scss"
import PropTypes from "prop-types"

const SearchFilters = ({ tabType, choosenType, toggleType }) => {
  tabType.sort()
  return (
    <ul className={filtersTaxo}>
      {tabType.map((type, key) => {
        let activeBool = false
        let nodeType = ""
        if (choosenType === type) {
          activeBool = true
        }
        switch (type) {
          case "node__carnet_d_adresse":
            nodeType = "Carnet d'adresses"
            break
          case "node__actualites":
            nodeType = "Actualité"
            break
          case "node__evenements":
            nodeType = "Évènement"
            break
          case "node__teleformulaires":
            nodeType = "Téléformulaire"
            break
          default:
            nodeType = "Page"
        }
        return (
          <li key={key}>
            <AdressItemTaxo
              onClick={() => {
                toggleType(choosenType, type)
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  toggleType(choosenType, type)
                }
              }}
              tabIndex="0"
              active={activeBool}
              aria-label={
                activeBool
                  ? nodeType + " - Supprimer le filtre actif"
                  : "Filtrer sur le type '" + nodeType + "'"
              }
            >
              {nodeType}
            </AdressItemTaxo>
          </li>
        )
      })}
    </ul>
  )
}

SearchFilters.propTypes = {
  tabType: PropTypes.array,
  choosenType: PropTypes.string,
  toggleType: PropTypes.func,
}

export default SearchFilters
